export const injectBearer=e=>e&&e.includes("Bearer")?e:`Bearer ${e}`;export const removeBearer=e=>e?e.replace(/^Bearer /,""):e;